var React = require('react');

function Products (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"dollar-r","d":"M12.34,4.108V2H10.935V4.108H6.25v7.964h4.685v5.153H6.25v1.405h4.685v2.108H12.34V18.631h4.685V10.667H12.34V5.514h4.685V4.108ZM10.935,5.514H7.655v5.153h3.279Zm1.405,6.559v5.153h3.279V12.072Z","transform":"translate(-2.057 -1.184)","fill":"currentColor","fillRule":"evenodd"}));
}

Products.defaultProps = {"id":"products","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Products;

Products.default = Products;
